import { gql } from "graphql-request"

export const allClusters = gql`
  query ($withDeleted: Boolean){
    pharmacy_clusters {
      id
      name
      pharmacy_clusterscode
      colorcode
      pharmacy_count(withDeleted:$withDeleted)
      agent {
        name
      }
    }
  }
`
